export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/c3960186dda9964ac2ddb7569c7190a406b7eb78/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"